module.exports = __webpack_public_path__ + "img/01.4b1e5cb6.jpg";